import React from 'react'
import './articles.css'
import Fade from 'react-reveal/Fade';


const Articles = () => {

  const details = [{
    id: 101,
    title: 'How to Implement Interval Scheduling Algorithm in Python',
    link: "https://www.geeksforgeeks.org/how-to-implement-interval-scheduling-algorithm-in-python/",
  },
  {
    id: 102,
    title: 'Convert Array of Datetimes into Array of Strings in Python',
    link: "https://www.geeksforgeeks.org/convert-array-of-datetimes-into-array-of-strings-in-python/",
  },
  {
    id: 103,
    title: 'How to invoke JavaScript code in an iframe from parent page',
    link: "https://www.geeksforgeeks.org/how-to-invoke-javascript-code-in-an-iframe-from-parent-page/",
  },
  {
    id: 104,
    title: 'Automated Website Scraping using Scrapy',
    link: "https://www.geeksforgeeks.org/automated-website-scraping-using-scrapy/",
  }
  ]

  return (
    <>
      <section id="articles" style={{ color: 'white' }}>


        <p className="artcilesHead">GeeksforGeeks Published Articles</p>


        <Fade bottom>
          <div className="Article_Container">

            <table className="ArticlesTable">
              <thead>
                <tr>
                  <th>Article Topic</th>
                  <th>Article Links</th>
                </tr>
              </thead>

              <tbody>

                {
                  details.map((article) => {

                    return (
                      <tr key={article.id}>
                        <td>{article.title}</td>
                        <td className='linkbox'><a href={article.link} target={'_blank'} rel=" noreferrer nooppener" > Read Article</a></td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>

          </div>

        </Fade>

        <a className='Abtn' href='https://auth.geeksforgeeks.org/user/harishcarpenter/articles' target={'_blank'} rel=" noreferrer nooppener"  >More Articles..</a>

      </section>
    </>
  )



}

export default Articles